<template>
  <div id="app">
    <!-- <headerBlack-view class="black"></headerBlack-view> -->
    <router-view></router-view>
    <!-- <footer-view></footer-view> -->
  </div>
</template>
<script>
export default {
  name: 'app',
  data() {
    return {

    }
  },
  components: {},
  computed: {
    key() {
      return this.$route.name
        ? this.$route.name + +new Date()
        : this.$route + +new Date()
    }
  },
  methods: {},
  created() { }
}
</script>
<style lang="less">
@import 'less/frontend.less';

// 阿里字体图标设置
.icon,
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}

@media screen and (max-width: 1500px) {
  #app {
    zoom: 0.9;
  }
}

@media screen and (max-width: 1100px) {
  #app {
    zoom: 0.8;
  }
}
</style>
